import classNames from 'classnames';
import React from 'react';

function GetFormIcon(result: 'W' | 'D' | 'L', size: number = 6) {
  const defaultClassNames = `text-white rounded-full flex items-center justify-center text-xs font-bold`;
  const style = {
    width: `${size * 4}px`,
    height: `${size * 4}px`,
  };

  switch (result) {
    case 'W':
      return (
        <div style={style} className={classNames('bg-emerald-600', defaultClassNames)}>
          В
        </div>
      );
    case 'D':
      return (
        <div style={style} className={classNames('bg-yellow-500', defaultClassNames)}>
          Н
        </div>
      );
    case 'L':
      return (
        <div style={style} className={classNames('bg-red-600', defaultClassNames)}>
          П
        </div>
      );
    default:
      return null;
  }
}

export default GetFormIcon;
